import type { Language } from '../types.js'

export const isTranslations = {
  authentication: {
    account: 'Aðgangur',
    accountOfCurrentUser: 'Aðgangur núverandi notanda',
    accountVerified: 'Aðgangur staðfestur.',
    alreadyActivated: 'Nú þegar virkjað',
    alreadyLoggedIn: 'Nú þegar innskráður',
    apiKey: 'API lykill',
    authenticated: 'Auðkenndur',
    backToLogin: 'Til baka í innskráningu',
    beginCreateFirstUser: 'Til að byrja, búðu til þinn fyrsta notanda.',
    changePassword: 'Breyta lykilorði',
    checkYourEmailForPasswordReset:
      'Ef netfangið er tengt reikningi muntu fá leiðbeiningar um að endurstilla lykilorðið þitt innan skamms. Vinsamlegast athugaðu ruslpóstmöppuna þína ef þú sérð ekki tölvupóstinn í pósthólfinu þínu.',
    confirmGeneration: 'Staðfesta sköpun',
    confirmPassword: 'Staðfesta lykilorð',
    createFirstUser: 'Búa til fyrsta notanda',
    emailNotValid: 'Netfangið sem gefið var upp er ekki gilt',
    emailOrUsername: 'Netfang eða notandanafn',
    emailSent: 'Tölvupóstur sendur',
    emailVerified: 'Netfang staðfest.',
    enableAPIKey: 'Virkja API lykil',
    failedToUnlock: 'Mistókst að opna',
    forceUnlock: 'Þvinga opnun',
    forgotPassword: 'Gleymdist lykilorð',
    forgotPasswordEmailInstructions:
      'Vinsamlegast sláðu inn netfangið þitt hér að neðan. Þú munt fá tölvupóst með leiðbeiningum um hvernig á að endurstilla lykilorðið þitt.',
    forgotPasswordUsernameInstructions:
      'Vinsamlegast sláðu inn notandanafnið þitt hér að neðan. Leiðbeiningar um hvernig á að endurstilla lykilorðið þitt verða sendar á netfangið sem tengt er notandanafninu þínu.',
    usernameNotValid: 'Notandanafnið sem gefið var upp er ekki gilt',

    forgotPasswordQuestion: 'Gleymdist lykilorðið?',
    generate: 'Búa til',
    generateNewAPIKey: 'Búa til nýjan API lykil',
    generatingNewAPIKeyWillInvalidate:
      'Að búa til nýjan API lykil mun <1>ógilda</1> fyrri lykil. Ertu viss um að þú viljir halda áfram?',
    lockUntil: 'Læsa þar til',
    logBackIn: 'Skráðu þig inn aftur',
    loggedIn: 'Til að skrá sig inn með öðrum notanda ættir þú að <0>skrá þig út</0> fyrst.',
    loggedInChangePassword:
      'Til að breyta lykilorðinu þínu, farðu á <0>reikninginn</0> þinn og breyttu lykilorðinu þar.',
    loggedOutInactivity: 'Þú hefur verið skráður út vegna óvirkni.',
    loggedOutSuccessfully: 'Þú hefur verið skráður út með góðum árangri.',
    loggingOut: 'Skrái út...',
    login: 'Innskráning',
    loginAttempts: 'Innskráningartilraunir',
    loginUser: 'Skrá notanda inn',
    loginWithAnotherUser:
      'Til að skrá sig inn með öðrum notanda ættir þú að <0>skrá þig út</0> fyrst.',
    logOut: 'Skrá út',
    logout: 'Útskráning',
    logoutSuccessful: 'Útskráning tókst.',
    logoutUser: 'Skrá notanda út',
    newAccountCreated:
      'Nýr reikningur hefur verið búinn til fyrir þig til að fá aðgang að <a href="{{serverURL}}">{{serverURL}}</a> Vinsamlegast smelltu á eftirfarandi hlekk eða límdu vefslóðina hér að neðan í vafrann þinn til að staðfesta netfangið þitt: <a href="{{verificationURL}}">{{verificationURL}}</a><br> Eftir að þú hefur staðfest netfangið þitt muntu geta skráð þig inn.',
    newAPIKeyGenerated: 'Nýr API lykill búinn til.',
    newPassword: 'Nýtt lykilorð',
    passed: 'Auðkenning tókst',
    passwordResetSuccessfully: 'Lykilorð endurstillt.',
    resetPassword: 'Endurstilla lykilorð',
    resetPasswordExpiration: 'Endurstilling lykilorðs rann út',
    resetPasswordToken: 'Endurstilla lykilorðs token',
    resetYourPassword: 'Endurstilltu lykilorðið þitt',
    stayLoggedIn: 'Halda innskráningu',
    successfullyRegisteredFirstUser: 'Fyrsti notandi skráður.',
    successfullyUnlocked: 'Opnun tókst',
    tokenRefreshSuccessful: 'Endurnýjun tokens tókst.',
    unableToVerify: 'Ekki hægt að staðfesta',
    username: 'Notandanafn',
    verified: 'Staðfest',
    verifiedSuccessfully: 'Staðfest',
    verify: 'Staðfesta',
    verifyUser: 'Staðfesta notanda',
    verifyYourEmail: 'Staðfestu netfangið þitt',
    youAreInactive:
      'Þú hefur ekki verið virkur í smá stund og verður fljótlega skráður út sjálfkrafa til öryggis. Viltu halda innskráningu?',
    youAreReceivingResetPassword:
      'Þú færð þetta vegna þess að þú (eða einhver annar) hefur beðið um að endurstilla lykilorðið fyrir reikninginn þinn. Vinsamlegast smelltu á eftirfarandi hlekk eða límdu þetta í vafrann þinn til að ljúka ferlinu:',
    youDidNotRequestPassword:
      'Ef þú baðst ekki um þetta, vinsamlegast hunsaðu þennan tölvupóst og lykilorðið þitt verður óbreytt.',
  },
  error: {
    accountAlreadyActivated: 'Þessi reikningur hefur þegar verið virkjaður.',
    autosaving: 'Vandamál kom upp við sjálfvirka vistun þessa skjals.',
    correctInvalidFields: 'Vinsamlegast leiðréttu ógild svæði.',
    deletingFile: 'Villa kom upp við að eyða skrá.',
    deletingTitle:
      'Villa kom upp við að eyða {{title}}. Vinsamlegast athugaðu tenginguna þína og reyndu aftur.',
    documentNotFound:
      'Skjalið með auðkenni {{id}} fannst ekki. Það kann að hafa verið eytt eða aldrei til, eða þú gætir ekki haft aðgang að því.',
    emailOrPasswordIncorrect: 'Netfangið eða lykilorðið sem gefið var upp er rangt.',
    followingFieldsInvalid_one: 'Eftirfarandi svæði er ógilt:',
    followingFieldsInvalid_other: 'Eftirfarandi svæði eru ógild:',
    incorrectCollection: 'Rangt safn',
    insufficientClipboardPermissions:
      'Aðgangur að klemmuspjaldi hafnað. Vinsamlegast athugaðu klemmuspjaldsheimildir þínar.',
    invalidClipboardData: 'Ógild klemmuspjaldsgögn.',
    invalidFileType: 'Ógild skráartegund',
    invalidFileTypeValue: 'Ógild skráartegund: {{value}}',
    invalidRequestArgs: 'Ógild viðföng send í beiðni: {{args}}',
    loadingDocument: 'Vandamál kom upp við að hlaða skjalinu með auðkenni {{id}}.',
    localesNotSaved_one: 'Eftirfarandi staðfærslu var ekki hægt að vista:',
    localesNotSaved_other: 'Eftirfarandi staðfærslur var ekki hægt að vista:',
    logoutFailed: 'Útskráning mistókst.',
    missingEmail: 'Vantar netfang.',
    missingIDOfDocument: 'Vantar auðkenni skjals til að uppfæra.',
    missingIDOfVersion: 'Vantar auðkenni útgáfu.',
    missingRequiredData: 'Vantar nauðsynleg gögn.',
    noFilesUploaded: 'Engum skrám var hlaðið upp.',
    noMatchedField: 'Ekkert samsvarandi svæði fannst fyrir "{{label}}"',
    notAllowedToAccessPage: 'Þér er ekki heimilt að fara á þessa síðu.',
    notAllowedToPerformAction: 'Þér er ekki heimilt að framkvæma þessa aðgerð.',
    notFound: 'Umbeðnar upplýsingar fundust ekki.',
    noUser: 'Enginn notandi',
    previewing: 'Vandamál kom upp við að forskoða þetta skjal.',
    problemUploadingFile: 'Vandamál kom upp við að hlaða upp skránni.',
    restoringTitle:
      'Villa kom upp við að endurheimta {{title}}. Vinsamlegast athugaðu tenginguna þína og reyndu aftur.',
    tokenInvalidOrExpired: 'Token er annað hvort ógilt eða útrunnið.',
    tokenNotProvided: 'Token var gefið upp.',
    unableToCopy: 'Ekki hægt að afrita.',
    unableToDeleteCount: 'Ekki hægt að eyða {{count}} af {{total}} {{label}}.',
    unableToReindexCollection: 'Villa við að endurskrá safn {{collection}}. Aðgerð hætt við.',
    unableToUpdateCount: 'Ekki hægt að uppfæra {{count}} af {{total}} {{label}}.',
    unauthorized: 'Óheimilt, þú verður að vera innskráður til að gera þessa beiðni.',
    unauthorizedAdmin: 'Óheimilt, þessi notandi hefur ekki aðgang að stjórnborðinu.',
    unknown: 'Óþekkt villa hefur komið upp.',
    unPublishingDocument: 'Vandamál kom upp við að fela þetta skjal.',
    unspecific: 'Villa hefur komið upp.',
    unverifiedEmail: 'Vinsamlegast staðfestu netfangið þitt áður en þú skráir þig inn.',
    userEmailAlreadyRegistered: 'Notandi með þetta netfang er þegar skráður.',
    userLocked: 'Þessi notandi er læstur vegna of margra misheppnaðra innskráningartilrauna.',
    usernameAlreadyRegistered: 'Notandi með þetta notandanafn er þegar skráður.',
    usernameOrPasswordIncorrect: 'Notandanafnið eða lykilorðið sem gefið var upp er rangt.',
    valueMustBeUnique: 'Gildi verður að vera einstakt',
    verificationTokenInvalid: 'Staðfestingartoken er ógilt.',
  },
  fields: {
    addLabel: 'Bæta við {{label}}',
    addLink: 'Bæta við hlekk',
    addNew: 'Bæta við nýju',
    addNewLabel: 'Bæta við nýju {{label}}',
    addRelationship: 'Bæta við tengingu',
    addUpload: 'Bæta við skráarupphleðslu',
    block: 'blokk',
    blocks: 'blokkir',
    blockType: 'Blokkartegund',
    chooseBetweenCustomTextOrDocument:
      'Veldu á milli þess að setja inn sérsniðna texta vefslóð eða tengja við annað skjal.',
    chooseDocumentToLink: 'Veldu skjal til að tengja við',
    chooseFromExisting: 'Velja úr fyrirliggjandi',
    chooseLabel: 'Velja {{label}}',
    collapseAll: 'Fella allt saman',
    customURL: 'Sérsniðin vefslóð',
    editLabelData: 'Breyta {{label}} gögnum',
    editLink: 'Breyta hlekk',
    editRelationship: 'Breyta tengingu',
    enterURL: 'Settu inn vefslóð',
    internalLink: 'Innri hlekkur',
    itemsAndMore: '{{items}} og {{count}} fleiri',
    labelRelationship: '{{label}} tenging',
    latitude: 'Breiddargráða',
    linkedTo: 'Tengt við <0>{{label}}</0>',
    linkType: 'Hlekkategund',
    longitude: 'Lengdargráða',
    newLabel: 'Nýtt {{label}}',
    openInNewTab: 'Opna í nýjum flipa',
    passwordsDoNotMatch: 'Lykilorð passa ekki saman.',
    relatedDocument: 'Tengt skjal',
    relationTo: 'Tenging við',
    removeRelationship: 'Fjarlægja tengingu',
    removeUpload: 'Fjarlægja skráarupphleðslu',
    saveChanges: 'Vista breytingar',
    searchForBlock: 'Leita að blokk',
    selectExistingLabel: 'Velja fyrirliggjandi {{label}}',
    selectFieldsToEdit: 'Velja svæði til að breyta',
    showAll: 'Sýna allt',
    swapRelationship: 'Skipta um tengingu',
    swapUpload: 'Skipta um skráarupphleðslu',
    textToDisplay: 'Texti til að birta',
    toggleBlock: 'Víxla blokk',
    uploadNewLabel: 'Hlaða upp nýju {{label}}',
  },
  folder: {
    browseByFolder: 'Flakka eftir möppu',
    byFolder: 'Eftir möppu',
    deleteFolder: 'Eyða möppu',
    folderName: 'Möppunafn',
    folders: 'Möppurnar',
    folderTypeDescription: 'Veldu hvaða tegund safnskjala ætti að vera leyfð í þessari möppu.',
    itemHasBeenMoved: '{{title}} hefur verið færð í {{folderName}}',
    itemHasBeenMovedToRoot: '{{title}} hefur verið færð í rótarmöppuna',
    itemsMovedToFolder: '{{title}} færð í {{folderName}}',
    itemsMovedToRoot: '{{title}} færð í rótarmöppuna',
    moveFolder: 'Færa möppu',
    moveItemsToFolderConfirmation:
      'Þú ert að fara að færa <1>{{count}} {{label}}</1> í <2>{{toFolder}}</2>. Ertu viss?',
    moveItemsToRootConfirmation:
      'Þú ert að fara að færa <1>{{count}} {{label}}</1> í rótarmöppuna. Ertu viss?',
    moveItemToFolderConfirmation:
      'Þú ert að fara að færa <1>{{title}}</1> í <2>{{toFolder}}</2>. Ertu viss?',
    moveItemToRootConfirmation:
      'Þú ert að fara að færa <1>{{title}}</1> í rótarmöppuna. Ertu viss?',
    movingFromFolder: 'Færi {{title}} úr {{fromFolder}}',
    newFolder: 'Ný mappa',
    noFolder: 'Engin mappa',
    renameFolder: 'Endurnefna möppu',
    searchByNameInFolder: 'Leita eftir nafni í {{folderName}}',
    selectFolderForItem: 'Veldu möppu fyrir {{title}}',
  },
  general: {
    name: 'Nafn',
    aboutToDelete: 'Þú ert að fara að eyða {{label}} <1>{{title}}</1>. Ertu viss?',
    aboutToDeleteCount_many: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToDeleteCount_one: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToDeleteCount_other: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToPermanentlyDelete:
      'Þú ert að fara að eyða {{label}} <1>{{title}}</1> varanlega. Ertu viss?',
    aboutToPermanentlyDeleteTrash:
      'Þú ert að fara að eyða <0>{{count}}</0> <1>{{label}}</1> varanlega úr ruslinu. Ertu viss?',
    aboutToRestore: 'Þú ert að fara að endurheimta {{label}} <1>{{title}}</1>. Ertu viss?',
    aboutToRestoreAsDraft:
      'Þú ert að fara að endurheimta {{label}} <1>{{title}}</1> sem drög. Ertu viss?',
    aboutToRestoreAsDraftCount: 'Þú ert að fara að endurheimta {{count}} {{label}} sem drög',
    aboutToRestoreCount: 'Þú ert að fara að endurheimta {{count}} {{label}}',
    aboutToTrash: 'Þú ert að fara að færa {{label}} <1>{{title}}</1> í ruslið. Ertu viss?',
    aboutToTrashCount: 'Þú ert að fara að færa {{count}} {{label}} í ruslið',
    addBelow: 'Bæta við neðan',
    addFilter: 'Bæta við síu',
    adminTheme: 'Stjórnborðsþema',
    all: 'Allt',
    allCollections: 'Öll söfn',
    allLocales: 'Allar staðfærslur',
    and: 'Og',
    anotherUser: 'Annar notandi',
    anotherUserTakenOver: 'Annar notandi hefur tekið yfir að breyta þessu skjali.',
    applyChanges: 'Virkja breytingar',
    ascending: 'Hækkandi',
    automatic: 'Sjálfvirkt',
    backToDashboard: 'Til baka í stjórnborð',
    cancel: 'Hætta við',
    changesNotSaved:
      'Breytingarnar þínar hafa ekki verið vistaðar. Ef þú ferð núna muntu missa breytingarnar þínar.',
    clear: 'Hreinsa',
    clearAll: 'Hreinsa allt',
    close: 'Loka',
    collapse: 'Fella saman',
    collections: 'Söfn',
    columns: 'Dálkar',
    columnToSort: 'Dálkur til að raða',
    confirm: 'Staðfesta',
    confirmCopy: 'Staðfesta afritun',
    confirmDeletion: 'Staðfesta eyðingu',
    confirmDuplication: 'Staðfesta tvítekning',
    confirmMove: 'Staðfesta færslu',
    confirmReindex: 'Endurskrá öll {{collections}}?',
    confirmReindexAll: 'Endurskrá öll söfn?',
    confirmReindexDescription:
      'Þetta mun fjarlægja fyrirliggjandi skrár og endurskrá skjöl í {{collections}} söfnunum.',
    confirmReindexDescriptionAll:
      'Þetta mun fjarlægja fyrirliggjandi skrár og endurskrá skjöl í öllum söfnum.',
    confirmRestoration: 'Staðfesta endurheimtu',
    copied: 'Afritað',
    copy: 'Afrita',
    copyField: 'Afrita svæði',
    copying: 'Afrita',
    copyRow: 'Afrita röð',
    copyWarning:
      'Þú ert að fara að skrifa yfir {{to}} með {{from}} fyrir {{label}} {{title}}. Ertu viss?',
    create: 'Búa til',
    created: 'Búið til',
    createdAt: 'Búið til',
    createNew: 'Búa til nýtt',
    createNewLabel: 'Búa til nýtt {{label}}',
    creating: 'Bý til',
    creatingNewLabel: 'Bý til nýtt {{label}}',
    currentlyEditing:
      'er núna að breyta þessu skjali. Ef þú tekur yfir munu þeir verða hindraðir frá því að halda áfram að breyta og gætu líka misst óvistaðar breytingar.',
    custom: 'Sérsniðið',
    dark: 'Dökkt',
    dashboard: 'Stjórnborð',
    delete: 'Eyða',
    deleted: 'Eytt',
    deletedAt: 'Eytt',
    deletedCountSuccessfully: 'Eyddi {{count}} {{label}}.',
    deletedSuccessfully: 'Eytt.',
    deleteLabel: 'Eyða {{label}}',
    deletePermanently: 'Sleppa rusli og eyða varanlega',
    deleting: 'Eyði...',
    depth: 'Dýpt',
    descending: 'Lækkandi',
    deselectAllRows: 'Afvelja allar raðir',
    document: 'Skjal',
    documentIsTrashed: 'Þetta {{label}} er í ruslinu og er skrifvarið.',
    documentLocked: 'Skjal læst',
    documents: 'Skjöl',
    duplicate: 'Tvítaka',
    duplicateWithoutSaving: 'Tvítaka án þess að vista breytingar',
    edit: 'Breyta',
    editAll: 'Breyta öllu',
    editedSince: 'Breytt síðan',
    editing: 'Breyti',
    editingLabel_many: 'Breyti {{count}} {{label}}',
    editingLabel_one: 'Breyti {{count}} {{label}}',
    editingLabel_other: 'Breyti {{count}} {{label}}',
    editingTakenOver: 'Breytingum tekið yfir',
    editLabel: 'Breyta {{label}}',
    email: 'Tölvupóstur',
    emailAddress: 'Netfang',
    emptyTrash: 'Tæma rusl',
    emptyTrashLabel: 'Tæma {{label}} rusl',
    enterAValue: 'Settu inn gildi',
    error: 'Villa',
    errors: 'Villur',
    exitLivePreview: 'Fara úr beinni forskoðun',
    export: 'Flytja út',
    fallbackToDefaultLocale: 'Fara til baka í sjálfgefna staðfærslu',
    false: 'Ósatt',
    filter: 'Sía',
    filters: 'Síur',
    filterWhere: 'Sía {{label}} þar sem',
    globals: 'Einstakir hlutir',
    goBack: 'Fara til baka',
    groupByLabel: 'Flokka eftir {{label}}',
    import: 'Flytja inn',
    isEditing: 'er að breyta',
    item: 'hlutur',
    items: 'hlutir',
    language: 'Tungumál',
    lastModified: 'Síðast breytt',
    leaveAnyway: 'Fara samt',
    leaveWithoutSaving: 'Fara án þess að vista',
    light: 'Ljóst',
    livePreview: 'Bein forskoðun',
    loading: 'Hleð',
    locale: 'Staðfærsla',
    locales: 'Staðfærslur',
    menu: 'Valmynd',
    moreOptions: 'Fleiri valkostir',
    move: 'Færa',
    moveConfirm: 'Þú ert að fara að færa {{count}} {{label}} í <1>{{destination}}</1>. Ertu viss?',
    moveCount: 'Færa {{count}} {{label}}',
    moveDown: 'Færa niður',
    moveUp: 'Færa upp',
    moving: 'Færi',
    movingCount: 'Færi {{count}} {{label}}',
    newLabel: 'Nýtt {{label}}',
    newPassword: 'Nýtt lykilorð',
    next: 'Næsta',
    no: 'Nei',
    noDateSelected: 'Engin dagsetning valin',
    noFiltersSet: 'Engar síur stilltar',
    noLabel: '<Ekkert {{label}}>',
    none: 'Ekkert',
    noOptions: 'Engir valkostir',
    noResults:
      'Ekkert {{label}} fannst. Annað hvort eru engin {{label}} til eða engin passa við síurnar sem þú tilgreindir hér að ofan.',
    notFound: 'Fannst ekki',
    nothingFound: 'Ekkert fannst',
    noTrashResults: 'Ekkert {{label}} í rusli.',
    noUpcomingEventsScheduled: 'Engir komandi viðburðir áætlaðir.',
    noValue: 'Ekkert gildi',
    of: 'af',
    only: 'Aðeins',
    open: 'Opna',
    or: 'Eða',
    order: 'Röð',
    overwriteExistingData: 'Skrifa yfir fyrirliggjandi svæðisgögn',
    pageNotFound: 'Síða fannst ekki',
    password: 'Lykilorð',
    pasteField: 'Líma svæði',
    pasteRow: 'Líma röð',
    payloadSettings: 'Payload stillingar',
    permanentlyDelete: 'Eyða varanlega',
    permanentlyDeletedCountSuccessfully: 'Eyddi {{count}} {{label}} varanlega.',
    perPage: 'Á síðu: {{limit}}',
    previous: 'Fyrri',
    reindex: 'Endurskrá',
    reindexingAll: 'Endurskrái öll {{collections}}.',
    remove: 'Fjarlægja',
    rename: 'Endurnefna',
    reset: 'Endurstilla',
    resetPreferences: 'Endurstilla þínar stillingar',
    resetPreferencesDescription:
      'Þetta mun endurstilla allar stillingarnar þínar í sjálfgefnar stillingar.',
    resettingPreferences: 'Endurstilli þínar stillingar.',
    restore: 'Endurheimta',
    restoreAsPublished: 'Endurheimta sem útgefna útgáfu',
    restoredCountSuccessfully: 'Endurheimti {{count}} {{label}}.',
    restoring: 'Endurheimti...',
    row: 'Röð',
    rows: 'Raðir',
    save: 'Vista',
    saving: 'Vista...',
    schedulePublishFor: 'Áætla útgáfu fyrir {{title}}',
    searchBy: 'Leita eftir {{label}}',
    select: 'Velja',
    selectAll: 'Velja allt {{count}} {{label}}',
    selectAllRows: 'Velja allar raðir',
    selectedCount: '{{count}} {{label}} valið',
    selectLabel: 'Velja {{label}}',
    selectValue: 'Velja gildi',
    showAllLabel: 'Sýna allt {{label}}',
    sorryNotFound: 'Því miður—það er ekkert sem samsvarar beiðninni þinni.',
    sort: 'Raða',
    sortByLabelDirection: 'Raða eftir {{label}} {{direction}}',
    stayOnThisPage: 'Halda á þessari síðu',
    submissionSuccessful: 'Innsending tókst.',
    submit: 'Senda inn',
    submitting: 'Sendi inn...',
    success: 'Árangur',
    successfullyCreated: '{{label}} búið til.',
    successfullyDuplicated: '{{label}} tvítekið.',
    successfullyReindexed: 'Endurskráði {{count}} af {{total}} skjölum úr {{collections}}',
    takeOver: 'Taka yfir',
    thisLanguage: 'Íslenska',
    time: 'Tími',
    timezone: 'Tímabelti',
    titleDeleted: '{{label}} "{{title}}".',
    titleRestored: '{{label}} "{{title}}" endurheimtur.',
    titleTrashed: '{{label}} "{{title}}" færður í rusl.',
    trash: 'Rusl',
    trashedCountSuccessfully: '{{count}} {{label}} færð í rusl.',
    true: 'Satt',
    unauthorized: 'Óheimilt',
    unsavedChanges:
      'Þú ert með óvistaðar breytingar. Vistaðu eða hættu við áður en þú heldur áfram.',
    unsavedChangesDuplicate: 'Þú ert með óvistaðar breytingar. Viltu halda áfram að tvítaka?',
    untitled: 'Án titils',
    upcomingEvents: 'Komandi viðburðir',
    updatedAt: 'Uppfært',
    updatedCountSuccessfully: 'Uppfærði {{count}} {{label}} með góðum árangri.',
    updatedLabelSuccessfully: 'Uppfærði {{label}} með góðum árangri.',
    updatedSuccessfully: 'Uppfært með góðum árangri.',
    updateForEveryone: 'Uppfæra fyrir alla',
    updating: 'Uppfæri',
    uploading: 'Hleð upp',
    uploadingBulk: 'Hleð upp {{current}} af {{total}}',
    user: 'Notandi',
    username: 'Notandanafn',
    users: 'Notendur',
    value: 'Gildi',
    viewing: 'Skoða',
    viewReadOnly: 'Skoða sem skrifvarið',
    welcome: 'Velkomin',
    yes: 'Já',
  },
  localization: {
    cannotCopySameLocale: 'Ekki hægt að afrita í sömu staðfærslu',
    copyFrom: 'Afrita frá',
    copyFromTo: 'Afrita frá {{from}} til {{to}}',
    copyTo: 'Afrita til',
    copyToLocale: 'Afrita í staðfærslu',
    localeToPublish: 'Staðfærsla til að gefa út',
    selectLocaleToCopy: 'Veldu staðfærslu til að afrita',
  },
  operators: {
    contains: 'inniheldur',
    equals: 'jafngildir',
    exists: 'er til',
    intersects: 'skarast',
    isGreaterThan: 'er stærra en',
    isGreaterThanOrEqualTo: 'er stærra en eða jafnt og',
    isIn: 'er í',
    isLessThan: 'er minna en',
    isLessThanOrEqualTo: 'er minna en eða jafnt og',
    isLike: 'er eins og',
    isNotEqualTo: 'er ekki jafnt og',
    isNotIn: 'er ekki í',
    isNotLike: 'er ekki eins og',
    near: 'nálægt',
    within: 'innan',
  },
  upload: {
    addFile: 'Bæta við skrá',
    addFiles: 'Bæta við skrám',
    bulkUpload: 'Magnupphleðsla',
    crop: 'Skera',
    cropToolDescription:
      'Dragðu horn valda svæðisins, teiknaðu nýtt svæði eða stilltu gildin hér að neðan.',
    download: 'Sækja',
    dragAndDrop: 'Dragðu og slepptu skrá',
    dragAndDropHere: 'eða dragðu og slepptu skrá hér',
    editImage: 'Breyta mynd',
    fileName: 'Skráarnafn',
    fileSize: 'Skráarstærð',
    filesToUpload: 'Skrár til að hlaða upp',
    fileToUpload: 'Skrá til að hlaða upp',
    focalPoint: 'Brennipunktur',
    focalPointDescription:
      'Dragðu brennipunktinn beint á forskoðunina eða stilltu gildin hér að neðan.',
    height: 'Hæð',
    lessInfo: 'Minni upplýsingar',
    moreInfo: 'Fleiri upplýsingar',
    noFile: 'Engin skrá',
    pasteURL: 'Líma vefslóð',
    previewSizes: 'Forskoðunarstærðir',
    selectCollectionToBrowse: 'Veldu safn til að flakka',
    selectFile: 'Veldu skrá',
    setCropArea: 'Stilla klippingarsvæði',
    setFocalPoint: 'Stilla brennipunkt',
    sizes: 'Stærðir',
    sizesFor: 'Stærðir fyrir {{label}}',
    width: 'Breidd',
  },
  validation: {
    emailAddress: 'Vinsamlegast settu inn gilt netfang.',
    enterNumber: 'Vinsamlegast settu inn gilda tölu.',
    fieldHasNo: 'Þetta svæði hefur ekkert {{label}}',
    greaterThanMax: '{{value}} er stærra en hámarks leyfða {{label}} sem er {{max}}.',
    invalidInput: 'Þetta svæði hefur ógilt inntak.',
    invalidSelection: 'Þetta svæði hefur ógilt val.',
    invalidSelections: 'Þetta svæði hefur eftirfarandi ógild völ:',
    lessThanMin: '{{value}} er minna en lágmarks leyfða {{label}} sem er {{min}}.',
    limitReached: 'Mörkum náð, aðeins er hægt að bæta við {{max}} hlutum.',
    longerThanMin:
      'Þetta gildi verður að vera lengra en lágmarkslengdin sem er {{minLength}} stafir.',
    notValidDate: '"{{value}}" er ekki gild dagsetning.',
    required: 'Þetta svæði er nauðsynlegt.',
    requiresAtLeast: 'Þetta svæði krefst að minnsta kosti {{count}} {{label}}.',
    requiresNoMoreThan: 'Þetta svæði krefst ekki meira en {{count}} {{label}}.',
    requiresTwoNumbers: 'Þetta svæði krefst tveggja talna.',
    shorterThanMax:
      'Þetta gildi verður að vera styttra en hámarkslengdin sem er {{maxLength}} stafir.',
    timezoneRequired: 'Tímabelti er nauðsynlegt.',
    trueOrFalse: 'Þetta svæði getur aðeins verið jafnt og satt eða ósatt.',
    username:
      'Vinsamlegast settu inn gilt notandanafn. Getur innihaldið bókstafi, tölur, bandstrik, punkta og undirstrik.',
    validUploadID: 'Þetta svæði er ekki gilt skráarupphleðslauðkenni.',
  },
  version: {
    type: 'Tegund',
    aboutToPublishSelection: 'Þú ert að fara að gefa út öll {{label}} í valinu. Ertu viss?',
    aboutToRestore:
      'Þú ert að fara að endurheimta þetta {{label}} skjal í ástandið sem það var í þann {{versionDate}}.',
    aboutToRestoreGlobal:
      'Þú ert að fara að endurheimta altæka {{label}} í ástandið sem það var í þann {{versionDate}}.',
    aboutToRevertToPublished:
      'Þú ert að fara að snúa breytingum þessa skjals til baka í útgefna ástandið. Ertu viss?',
    aboutToUnpublish: 'Þú ert að fara að fela þetta skjal. Ertu viss?',
    aboutToUnpublishSelection: 'Þú ert að fara að fela öll {{label}} í valinu. Ertu viss?',
    autosave: 'Sjálfvirk vistun',
    autosavedSuccessfully: 'Sjálfvirk vistun tókst.',
    autosavedVersion: 'Sjálfvirk vistuð útgáfa',
    changed: 'Breytt',
    changedFieldsCount_one: '{{count}} breytt svæði',
    changedFieldsCount_other: '{{count}} breytt svæði',
    compareVersion: 'Bera útgáfu saman við:',
    compareVersions: 'Bera útgáfur saman',
    comparingAgainst: 'Ber saman við',
    confirmPublish: 'Staðfesta útgáfu',
    confirmRevertToSaved: 'Staðfesta að snúa til baka í vistað',
    confirmUnpublish: 'Staðfesta að fela',
    confirmVersionRestoration: 'Staðfesta endurheimtu útgáfu',
    currentDocumentStatus: 'Núverandi {{docStatus}} skjal',
    currentDraft: 'Núverandi drög',
    currentlyPublished: 'Nú útgefið',
    currentlyViewing: 'Skoða núna',
    currentPublishedVersion: 'Núverandi útgefin útgáfa',
    draft: 'Drög',
    draftSavedSuccessfully: 'Drög vistuð með góðum árangri.',
    lastSavedAgo: 'Síðast vistað {{distance}} síðan',
    modifiedOnly: 'Aðeins breytt',
    moreVersions: 'Fleiri útgáfur...',
    noFurtherVersionsFound: 'Engar fleiri útgáfur fundust',
    noRowsFound: 'Ekkert {{label}} fannst',
    noRowsSelected: 'Ekkert {{label}} valið',
    preview: 'Forskoðun',
    previouslyDraft: 'Áður drög',
    previouslyPublished: 'Áður útgefið',
    previousVersion: 'Fyrri útgáfa',
    problemRestoringVersion: 'Vandamál kom upp við að endurheimta þessa útgáfu',
    publish: 'Gefa út',
    publishAllLocales: 'Gefa út allar staðfærslur',
    publishChanges: 'Gefa út breytingar',
    published: 'Útgefið',
    publishIn: 'Gefa út í {{locale}}',
    publishing: 'Gef út',
    restoreAsDraft: 'Endurheimta sem drög',
    restoredSuccessfully: 'Endurheimtur með góðum árangri.',
    restoreThisVersion: 'Endurheimta þessa útgáfu',
    restoring: 'Endurheimti...',
    reverting: 'Sný til baka...',
    revertToPublished: 'Snúa til baka í útgefið',
    saveDraft: 'Vista drög',
    scheduledSuccessfully: 'Áætlað.',
    schedulePublish: 'Áætla útgáfu',
    selectLocales: 'Veldu staðfærslur til að birta',
    selectVersionToCompare: 'Veldu útgáfu til að bera saman',
    showingVersionsFor: 'Sýni útgáfur fyrir:',
    showLocales: 'Sýna staðfærslur:',
    specificVersion: 'Tiltekin útgáfa',
    status: 'Staða',
    unpublish: 'Fela',
    unpublishing: 'Fel...',
    version: 'Útgáfa',
    versionAgo: '{{distance}} síðan',
    versionCount_many: '{{count}} útgáfur fundust',
    versionCount_none: 'Engar útgáfur fundust',
    versionCount_one: '{{count}} útgáfa fannst',
    versionCount_other: '{{count}} útgáfur fundust',
    versionCreatedOn: '{{version}} búin til þann:',
    versionID: 'Útgáfuauðkenni',
    versions: 'Útgáfur',
    viewingVersion: 'Skoða útgáfu fyrir {{entityLabel}} {{documentTitle}}',
    viewingVersionGlobal: 'Skoða útgáfu fyrir einstaka {{entityLabel}}',
    viewingVersions: 'Skoða útgáfur fyrir {{entityLabel}} {{documentTitle}}',
    viewingVersionsGlobal: 'Skoða útgáfur fyrir einstaka {{entityLabel}}',
  },
}

export const is: Language = {
  dateFNSKey: 'is',
  translations: isTranslations,
}
